import VideoWall from '@/components/SolutionsTemplate/VideoWall';
import EyebrowLabel from '@/components/SolutionsTemplate/EyebrowLabel';
import GradientTitle from '@/components/SolutionsTemplate/GradientTitle';
import styles from "@/styles/solutionsTemplate/seeItInAction.module.scss";

interface Props {
    type: string,
    jsonData: any,
}

export default function SeeItInAction({
    type,
    jsonData,
}: Props) {

    return (
        <div className = {styles.rootDiv}>
            
            <EyebrowLabel type = {type} text = {jsonData.eyebrowLabel}/>

            <div style = {{width: "fit-content", margin: "0 auto", marginTop: "20px"}}>
                <GradientTitle
                    text = {jsonData.title}
                    centeredText = {true}/>
            </div>

            <div 
            className = {styles.subtitleDiv}
            dangerouslySetInnerHTML = {{__html: jsonData.subtitle   }}/>

            <VideoWall type = {type} videos = {jsonData.videoWall}/>
        </div>
    );
}